import { Typography } from "@mui/material";
import CustomButton from "../../../components/common/button/CustomButton";
import useStyles from "../../../components/pageTitle/styles";
import FileUploader from "../../../components/common/fileUploader/FileUploader";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import {
  getAllTCDocumentListAction,
  getTCDocumentAction,
  setTCDocumentAction,
  setUpdateTCDocumentAction,
} from "../../../store/reducers/documentSlice";
import CustomerFeedback from "./CustomerFeedback";
import { setNotificationAction } from "../../../store/reducers/mmymSlice";
import NoPermissionPage from "../../../components/common/NoPermissionPage";

interface DocumentsDetailsProps {
  settingFeedbackModulePermission: any;
  settingDocumentModulePermission: any;
}

const DocumentsDetails: React.FC<DocumentsDetailsProps> = ({
  settingFeedbackModulePermission,
  settingDocumentModulePermission,
}) => {
  const classes = useStyles();

  const { user } = useSelector((state: any) => state?.user);
  const dispatch = useDispatch();

  const { selectedDocument, isDocumentResponse, tcDocumentList } = useSelector(
    (state: any) => state.document
  );
 
  useEffect(() => {
    if (
      user?.user?.roles?.includes("Owner") ||
      user?.user?.roles?.includes("TENANT") ||
      settingDocumentModulePermission?.read
    ) {
      dispatch(getAllTCDocumentListAction());
    }
    return () => {
      dispatch(setNotificationAction({ message: [], severity: "info" }));
    };
  }, []);

  useEffect(() => {
    if (selectedDocument) {
      // Open the PDF in a new tab
      window.open(selectedDocument, "_blank");
      dispatch(setTCDocumentAction(null));
    }
  }, [selectedDocument]);

  useEffect(() => {
    if (isDocumentResponse) {
      dispatch(setUpdateTCDocumentAction(false));
    }
  }, [isDocumentResponse]);
  const OnViewHablde = () => {
    dispatch(getTCDocumentAction({ docName: "terms_conditions" }));
  };



  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingTop: "16px",
        }}
      >
        <Typography variant="h5" fontWeight={700}>
          Terms & Conditions
        </Typography>
        <div style={{ display: "flex", alignItems: "center" }}>
          <FileUploader
            onImageUpload={() => {}}
            width={60}
            height={60}
            accept="application/pdf"
            page="docs"
            showUploadButton={true}
            btnName={tcDocumentList?.doc_id ? "Replace T&C" : "Upload T&C"}
          />
          {tcDocumentList?.doc_id && (
            <CustomButton
              title={"View T&C"}
              style={{ marginLeft: "6px" }}
              onClick={OnViewHablde}
            />
          )}
        </div>
      </div>
      <>
        {user?.user?.roles?.includes("Owner") ||
        user?.user?.roles?.includes("TENANT") ||
        settingFeedbackModulePermission?.read ? (
          <CustomerFeedback />
        ) : (
          <NoPermissionPage />
        )}
      </>
      {/* <PageTitle
        title="Terms & Conditions"
        button="Upload T&C"
        // onClick={handleOpen}
      />
      <PageTitle
        title="Terms & Conditions"
        button="Replace T&C"
        button1="View T&C"
        // onClick={handleOpen}
      /> */}

      {/* TODO: dropdown */}
      {/* <div className={classes.pageTitleContainer}>
            <Typography sx={{textTransform:'capitalize !important'}}
            variant={"h5"}
            fontWeight={700}
            >
                Terms & Conditions
            </Typography>
            <div>
                <DropdownLinks />
            </div>
        </div> */}
    </>
  );
};

export default DocumentsDetails;
